export const isFullscreen = () => {
    const e = document;
    const el =
           e['fullscreenElement']
        || e['webkitFullscreenElement']
        || e['webkitCurrentFullScreenElement']
        || e['msFullscreenElement']
        || e['mozFullScreenElement']
    ;
    return !!el;
};

export const fullscreenSupport = (e) => {
    const func =
        e['requestFullscreen']
        || e['webkitRequestFullscreen']
        || e['webkitRequestFullScreen']
        || e['webkitEnterFullscreen']
        || e['msRequestFullscreen']
        || e['mozRequestFullScreen']
    ;

    return !!func;
};

export const fullscreenOpen = (e) => {
    try {
        const func =
               e['requestFullscreen']
            || e['webkitRequestFullscreen']
            || e['webkitRequestFullScreen']
            || e['webkitEnterFullscreen']
            || e['msRequestFullscreen']
            || e['mozRequestFullScreen']
        ;
        if (func) {
            func.call(e);
            return true;
        }
    } catch (e) {
        console.error(e);
    }
    return false;
};

export const fullscreenClose = () => {
    const e = document;
    try {
        const func =
               e['exitFullscreen']
            || e['webkitExitFullscreen']
            || e['webkitCancelFullScreen']
            || e['msExitFullscreen']
            || e['mozCancelFullScreen']
        ;
        if (func) {
            func.call(e);
            return true;
        }
    } catch (e) {
        console.error(e);
    }
    return false;
};
